module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1525-7675df7d54da5f10e44d5b6c49dbc126.png";